import { Component, Prop, h, Host } from '@stencil/core';
import { parseJsonProp } from '../../../../../utils/helpers/hydration';

const COMPONENT_NAME = 'sn-stats-type-1';
/**
 * Stats component for SignNow brand key metrics. Displays up to 3 animated counter cards
 * with value, caption, and description fields. Delegates rendering to stats-type-6.
 *
 * @product signnow
 * @version 2.0.0
 * @category SignNow
 * @source stats
 * @example
 *   <sn-stats-type-1
 *     counters='[{"value":"24x","caption":"Collect signatures","description":"faster"},{"value":"$30","caption":"Reduce costs by","description":"per document"},{"value":"40h","caption":"Save up to","description":"per employee / month"}]'
 *   ></sn-stats-type-1>
 */
@Component({
  tag: 'sn-stats-type-1',
  styleUrl: 'index.scss',
  shadow: false,
})
export class SNStatsType1 {
  @Prop() colorMode: 'signnow' | 'inverted' = 'signnow';

  /**
   * Statistics counters list
   * @content
   * @type {array}
   * @item.type {object}
   * @item.property {string} value - Counter value (e.g. "24x")
   * @item.property {string} caption - Counter caption text
   * @item.property {string} description - Counter description text
   * @item.required value
   * @item.required caption
   * @item.content value caption description
   * @minItems 1
   */
  @Prop({ mutable: true }) counters!: any[] | string;

  componentWillLoad() {
    this.counters = parseJsonProp(this.counters, [
      { value: '24x', caption: 'Collect signatures', description: 'faster' },
      { value: '$30', caption: 'Reduce costs by', description: 'per document' },
      { value: '40h', caption: 'Save up to', description: 'per employee / month' },
    ]);
  }

  render() {
    return (
      <Host class={COMPONENT_NAME} data-color-mode={this.colorMode}>
        <stats-type-6
          counters={this.counters as any[]}
          animationType="none"
          animationMode="all-at-once"
          animationDuration={600}
          counterAnimationDuration={2000}
          animationEasing="ease"
          animationDelay={200}
          align="left"
        ></stats-type-6>
      </Host>
    );
  }
}
